package com.xtream.ui.tv.presentation.movies

import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.paging.compose.collectAsLazyPagingItems
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.movies
import com.xtream.composeapp.viewmodel.VodStreamsViewModel
import com.xtream.data_kmp.dto.VodStream
import com.xtream.ui.platform.adaptiveValue
import com.xtream.ui.tv.presentation.common.ContentGridTvScreen
import com.xtream.ui.ui.widget.NetworkImageCard
import com.xtream.ui.ui.widget.Visibility
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel


@OptIn(ExperimentalStdlibApi::class)
@Composable
fun MoviesGridTvScreen(
    modifier: Modifier=  Modifier,
    id: Int? = null,
    query: String?=null,
    title: String?=null,
    navKey: Screen.MoviesGrid,

    ){
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current
    val rootNavViewModel: RootNavViewModel =koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )
    val vodStreamsViewModel: VodStreamsViewModel = koinViewModel( key="vodStream_${navKey::class.simpleName}${navKey.hashCode()}")/* hiltViewModel<VodStreamsViewModel, VodStreamsViewModel.Factory>(
        creationCallback = { factory ->
            factory.create(navKey)
        }
    )*/
    LaunchedEffect(Unit) {
        vodStreamsViewModel.searchByCategoryFlow.value = id
    }
    val scrollState = rememberSaveable(saver = LazyGridState.Saver) {
        LazyGridState()
    }

    LaunchedEffect( query) {
      //  vodStreamsViewModel.searchByCategoryFlow.value = id
       // vodStreamsViewModel.search( query)

      //  scrollState.scrollToItem(0)
    }

    val homeScreenPagedItems
            = vodStreamsViewModel.vodStreamsFilteredPagingFlow.collectAsLazyPagingItems()

val columnsNum= adaptiveValue(expandedValue = 7, compactValue = 3, default = 3)
    ContentGridTvScreen(
        scrollState = scrollState,
        modifier = modifier,
        numColumns = columnsNum,
        title  = {
            Text(
                stringResource(Res.string.movies),
                style = MaterialTheme.typography.headlineMedium
            )
        },
        subtitle  = title?.takeIf { it.isNotEmpty() }?.let { {
            Text(title, style = MaterialTheme.typography.titleMedium)}},

        /*actions = {
            IconButton(
                onClick = { *//* Favorite action *//* },
                modifier = Modifier
                    .size(48.dp)
                    .background(Color.Transparent, CircleShape),
                colors = IconButtonDefaults.iconButtonColors(
                    contentColor = Color.White
                )
            ) {
                Icon(
                    imageVector = Icons.AutoMirrored.Filled.Sort,
                    contentDescription = stringResource( R.string.filter),
                )
            }
        },*/

        carousel = {

        },
        lazyPagingItems = homeScreenPagedItems,

        ){

        (it as? VodStream?)?.let { stream->
            NetworkImageCard(
                src=stream.streamIcon,
                useAutoAlpha = true,
              title = stream.name?:"",
                /*   description = stream.formattedRating()?:"",*/
                //dependOnWidth = false,
                infoSectionVisibility= Visibility.VISIBLE_ON_FOCUS,
             width = (-1).dp,
// to fill width
                onClick = {
                    rootNavViewModel.navigate(Screen.MovieDetail(stream.streamId))
                }
            )
        }

    }

    /*
    *  /*LazyVerticalGrid(
        state= scrollState,
        columns = GridCells.Fixed(columnsNum), // 3 columns
        modifier = modifier,
        contentPadding = androidx.compose.foundation.layout.PaddingValues(start = 48.dp, end = 48.dp,top=12.dp, bottom = 24.dp),
        horizontalArrangement =  androidx.compose.foundation.layout.Arrangement.spacedBy(8.dp),
        verticalArrangement =  androidx.compose.foundation.layout.Arrangement.spacedBy(14.dp),

    ) {
        items(homeScreenPagedItems.itemCount,
            key = homeScreenPagedItems.itemKey{ it->it.streamId},
            contentType = {null
            }
        ) {
            val stream = homeScreenPagedItems[it]
            (stream as? VodStream?)?.let {stream->
                NetworkImageCard(
                    src=stream.streamIcon,
                    useAutoAlpha = true,

                    title = stream.name?:"",
                    description = stream.formattedRating()?:"",
                    //dependOnWidth = false,
                    infoSectionVisibility=InfoSectionVisibility.HIDE,
                    width = (-1).dp,// to fill width
                    onClick = {
                        rootNavViewModel.navigate(Screen.MovieDetail(stream.streamId))
                    }
                )


        }
    }}*/*/


}







